import React from 'react';
import './FullScreenLoader.css';

export interface FullScreenLoaderProps {
  /**
   * Texto sob o spinner. O default cobre o caso comum; passe algo específico
   * quando o usuário ganha em saber O QUE está carregando ("Carregando catálogo
   * de termos...", "Carregando dados do veículo...").
   */
  mensagem?: string;
}

/**
 * Loader de tela cheia — o indicador único de carregamento do app (01/09/2026).
 *
 * Substituiu os "Carregando..." soltos no meio das telas, que apareciam em
 * lugares diferentes (dentro da tabela, acima do card, no lugar do conteúdo) e
 * às vezes empurravam o layout ao entrar e sair.
 *
 * Cobre a tela inteira de propósito: enquanto carrega, nada mais deve ser
 * clicado. Para estado de BOTÃO (ex.: "Salvando...") continue usando o próprio
 * botão desabilitado — não é caso de overlay.
 */
const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({
  mensagem = 'Carregando...',
}) => (
  <div className="loader-overlay" role="status" aria-live="polite" aria-busy="true">
    <div className="loader" />
    <span className="font-loading">{mensagem}</span>
  </div>
);

export default FullScreenLoader;
